import { render, staticRenderFns } from "./recoveryFormEmail.vue?vue&type=template&id=1b6b9e24&scoped=true&"
import script from "./recoveryFormEmail.vue?vue&type=script&lang=js&"
export * from "./recoveryFormEmail.vue?vue&type=script&lang=js&"
import style0 from "./recoveryFormEmail.vue?vue&type=style&index=0&id=1b6b9e24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6b9e24",
  null
  
)

export default component.exports